import React, { useState, useEffect } from 'react';
import './Hero.css';

const heroImages = [
  '/images/hero/modern-exterior-1.jpeg',
  '/images/hero/commercial-building.jpeg',
  '/images/hero/building-exterior.jpeg'
];

const Hero = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      // Hide scroll indicator after scrolling 100px
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-rotate hero images
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero" id="home">
      <div className="hero__background">
        {/* Slideshow Background */}
        {heroImages.map((img, index) => (
          <div 
            key={index}
            className={`hero__bg-image ${index === currentImageIndex ? 'hero__bg-image--active' : ''}`}
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}
        <div className="hero__overlay"></div>
        <div className="hero__pattern"></div>
        <div className="hero__gradient-orb hero__gradient-orb--1"></div>
        <div className="hero__gradient-orb hero__gradient-orb--2"></div>
      </div>
      
      <div className="hero__inner">
        <div className="hero__content">
          <span className="hero__tagline">
            Professional · Innovative · Reliable
          </span>
          
          <h1 className="hero__title">
            Your Vision,
            <span className="hero__title--accent"> Our</span>
            <br />Expertise
          </h1>
          
          <p className="hero__description">
            We transform your construction dreams into reality with sustainable, 
            creative & efficient solutions. From residential homes to commercial 
            developments, we deliver exceptional results across Tanzania.
          </p>
          
          <div className="hero__cta">
            <a href="#contact" className="btn btn--primary">
              <span>Get a Free Quote</span>
              <svg className="btn__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M5 12h14M12 5l7 7-7 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="#projects" className="btn btn--outline">
              View Our Projects
            </a>
          </div>
        </div>
        
        {/* Floating Stats Card */}
        <div className="hero__stats-card">
          <div className="stats-card__item">
            <span className="stats-card__number">1000+</span>
            <span className="stats-card__label">Projects Completed</span>
          </div>
          <div className="stats-card__divider"></div>
          <div className="stats-card__item">
            <span className="stats-card__number">10+</span>
            <span className="stats-card__label">Years of Experience</span>
          </div>
          <div className="stats-card__divider"></div>
          <div className="stats-card__item">
            <span className="stats-card__number">100%</span>
            <span className="stats-card__label">Client Satisfaction</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - fades out on scroll */}
      <div className={`hero__scroll ${isScrolled ? 'hero__scroll--hidden' : ''}`}>
        <span>Scroll</span>
        <div className="hero__scroll-line">
          <div className="hero__scroll-dot"></div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="hero__decoration hero__decoration--1">
        <svg viewBox="0 0 100 100" fill="none">
          <rect x="10" y="10" width="80" height="80" stroke="currentColor" strokeWidth="0.5" opacity="0.2"/>
          <rect x="20" y="20" width="60" height="60" stroke="currentColor" strokeWidth="0.5" opacity="0.3"/>
          <rect x="30" y="30" width="40" height="40" stroke="currentColor" strokeWidth="0.5" opacity="0.4"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
